// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#order-bills {\n  max-width: 1080px;\n  width: 100vw;\n  margin: 0px 0px -10px;\n}\n#order-bills .k-grid {\n  margin: 0px 0px 10px;\n}\n#order-bills .k-grid .k-detail-row .has-secondary-tabs .cp-secondary-tabs .k-content {\n  padding: 20px 0px;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
